import { render } from "./RatComponent.vue?vue&type=template&id=1ce42bf2&scoped=true"
import script from "./RatComponent.vue?vue&type=script&lang=js"
export * from "./RatComponent.vue?vue&type=script&lang=js"

import "./RatComponent.vue?vue&type=style&index=0&id=1ce42bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce42bf2"]])

export default __exports__